import Vue from 'vue'
import { cloneDeep } from 'lodash'

import { sortByKey } from '@/utilities'

import { defaultQuickInterviewState } from './state'

export const QuickInterviewMutations = {

  // STEPS

  setQuickInterviewsSteps: (state, value) => {
    state.quickInterviewsSteps = value
  },

  setQuickInterviewsStep: (state, value) => {
    const index = state.quickInterviewsSteps.findIndex(qis => qis.id === value.id)

    if (index < 0) state.quickInterviewsSteps.push(value)
    else Vue.set(state.quickInterviewsSteps, index, value)
  },

  updateQuickInterviewsStep: (state, value) => {
    const index = state.quickInterviewsSteps.findIndex(qis => qis.id === value.id)

    if (index < 0) state.quickInterviewsSteps.push(value)
    else Vue.set(state.quickInterviewsSteps, index, { ...state.quickInterviewsSteps[index], ...value })
  },

  removeQuickInterviewsStep: (state, value) => {
    const index = state.quickInterviewsSteps.findIndex(qis => qis.id === value.id)

    if (index > -1) state.quickInterviewsSteps.splice(index, 1)
  },

  // QUICK INTERVIEW

  resetQuickInterview: state => {
    const data = cloneDeep(defaultQuickInterviewState)

    const steps = cloneDeep(state.quickInterviewsSteps).
      map(step => {
        return {
          buttonLabel: step.button_label,
          component: step.component,
          data: {},
          errorList: [],
          hasChanged: false,
          instructions: step.instructions,
          isReviewed: false,
          position: step.position,
          requiresReview: step.requires_review,
          title: step.title,
        }
      })

    data.steps_data = sortByKey(steps, 'position')

    state.quickInterview = data
  },

  setQuickInterview: (state, value) => {
    state.quickInterview = {
      ...state.quickInterview,
      ...value,
    }
  },

  updateQuickInterview: (state, value) => {
    if (state.quickInterview.id === value.id) {
      state.quickInterview = {
        ...state.quickInterview,
        ...value,
      }
    }

    const index = state.quickInterviewsList.findIndex(qil => qil.id === value.id)
    if (index < 0) return

    Vue.set(state.quickInterviewsList, index, { ...state.quickInterviewsList[index], ...value })
  },

  setQuickInterviewsList: (state, value) => { state.quickInterviewsList = value },
}
